
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1705"}},[_c('path',{attrs:{"data-name":"Rectangle 2409","fill":"none","d":"M0 0h25v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1704","fill":"#3c3c3c"}},[_c('path',{attrs:{"data-name":"Path 1055","d":"M20.5 20h-16a1.5 1.5 0 010-3h16a1.5 1.5 0 010 3z"}}),_c('path',{attrs:{"data-name":"Path 1056","d":"M21 15H4a2.5 2.5 0 01-2.5-2.5v-10A2.5 2.5 0 014 0h17a2.5 2.5 0 012.5 2.5v10A2.5 2.5 0 0121 15zm-.5-11.25a.752.752 0 00-.75-.751H5.25a.752.752 0 00-.75.751v7.5a.751.751 0 00.75.749h14.5a.751.751 0 00.75-.749z"}})])])])
          )
        }
      }
    